import styled from '@emotion/styled';
import { rem } from '@utils';

const Root = styled.h2`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(16)};
  font-style: normal;
  font-weight: 600;
  line-height: ${rem(24)};
  margin-bottom: ${rem(-16)};
  width: 100%;
`;

export default {
  Root
};
